export default "__VITE_ASSET__DnO2FH5R__"